import React from 'react';
import classes from './Spinner.css'

const spinner = (props) => {
  let spinnerClasses = [classes.loader]

  if (props.center) {
    spinnerClasses.push(classes.center);
  }

  return <div className={spinnerClasses.join(' ')}>Loading...</div>
}

export default spinner;


// WEBPACK FOOTER //
// ./src/components/UI/Spinner/Spinner.js